import React, { Component } from 'react';
import { connect } from 'react-redux';

import UserSideMenu from '../../menu/UserSideMenu';
import Header from '../common/HeaderAfterLogin';

import { postServerDataWithPath } from '../../action/common_action';

import { getUserData } from '../../util/util';
import { endPoints, url } from '../../config';
import { history } from '../../history/history';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
class EditKycDetailComp extends Component {
  constructor(props) {
    super(props);
    //set initial state
    this.state = {
      userData: getUserData(),
      kycDetails: {},
      uploadedFileArr: [],
      gst_Certificate_file: null,
      bill_address_cert_file: null
    };
  };

  //Check date for kyc
  componentWillMount = () => {
    if (this.props.location.state && this.props.location.state.kycDetails) {
      let { kycDetails } = this.props.location.state;
      this.setState({ kycDetails });

    }
    else {
      history.push('/kycdetails');
    }
  };

  //Update the fields
  handleChange = event => {
    
    let { name, value } = event.target;
    let { kycDetails } = this.state;

      this.setState({
        kycDetails: {
          ...kycDetails,
          [name]: value
        }
      });
    

  };

  //Handling the files
  handleFiles = event => {
    let { name, files } = event.target;
    let { kycDetails, uploadedFileArr } = this.state;
    let index = uploadedFileArr.indexOf(name);
    if (index == -1) {
      uploadedFileArr.push(name);
    }
    this.setState({
      kycDetails: {
        ...kycDetails,
        [name]: files
      },
      uploadedFileArr,
      gst_Certificate_file: files,
      bill_address_cert_file: files
    });
  }

  //Updating the kyc details
  updateKycDetails = () => {
    let { kycDetails, uploadedFileArr, userData } = this.state;
    let formData = new FormData();
    delete kycDetails.gst_Certificate_file1
    delete kycDetails.pan_card_cert_file1
    delete kycDetails.bill_address_cert_file1
    for (let key in kycDetails) {

      // console.log("value",value);
      if(key =="pan_number"){

        let regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        if(regpan.test(kycDetails[key])){

          // alert("Pan no alert >>>");

        } else {

          // alert("Pan number is invalid.Please give correct Pan number!!");
          toast.error('Pan number is invalid.Please give correct Pan number!!', {
            position:toast.POSITION.TOP_CENTER,
            autoClose:6000,
            hideProgressBar:true,
            toastId:"1"
         });
          return false;
        }
      }
      
      if (key != "_id" && key != "createdAt" && key != "updatedAt" && key != "userEmail") {
        if (uploadedFileArr.includes(key)) {
          formData.append(key, kycDetails[key].length > 0 ? kycDetails[key][0] : "");
        }
        else {
          formData.append(key, kycDetails[key]);
        }
      }
    };
    formData.append('userEmail', userData.email);
    this.props.updateKycDetails(endPoints.updateKycDetails, formData, '/kycdetails');
  }

  render() {
    let { kycDetails, uploadedFileArr } = this.state;
    return (
      <div className="main_wrapper">
        <UserSideMenu {...this.props} />
        <div className="dashboard_right_wrapper create_camp_container">
          <div className="right_wrapper_inner">
            <Header />
            <div className="dash_content_wrapper">

              <div className="content_wrapper_inner detail_content">
                <div className="create_kyc_wrapper">
                  <h2 className="detail_kyc_header">KYC DETAILS</h2>
                  <div className="kycdetails_wrapper">
                    <h2 className="kycheader">PRIMARY DETAILS</h2>
                    <div className="wrapper_deials_kyc">
                      <div className="detail_inner">
                        <span className="detailinner_header">Contact Person</span>
                        <div className="detailinner_input">
                          <input type="text" name="name" value={kycDetails.name ? kycDetails.name : ""}
                            onChange={this.handleChange} placeholder="Enter Contact Person" />
                        </div>
                      </div>
                      <div className="detail_inner">
                        <span className="detailinner_header">Email Id</span>
                        <div className="detailinner_input">
                          <input type="text" name="email" value={kycDetails.email ? kycDetails.email : ""}
                            onChange={this.handleChange} placeholder="Enter Email Id" />
                        </div>
                      </div>
                      <div className="detail_inner">
                        <span className="detailinner_header">Phone Number</span>
                        <div className="detailinner_input">
                          <input type="text" name="phone_number" value={kycDetails.phone_number ? kycDetails.phone_number : ""}
                            onChange={this.handleChange} placeholder="Enter Phone Number" />
                        </div>
                      </div>
                      <div className="detail_inner margintop">
                        <span className="detailinner_header">GST Number</span>
                        <div className="detailinner_input">
                          <input type="text" name="gst_Number" value={kycDetails.gst_Number ? kycDetails.gst_Number : ""}
                            onChange={this.handleChange} placeholder="Enter GST Number" />
                        </div>
                      </div>
                      <div className="detail_inner margintop">
                        <span className="detailinner_header">GST Address</span>
                        <div className="detailinner_input">
                          <textarea name="gst_Address" value={kycDetails.gst_Address ? kycDetails.gst_Address : ""}
                            onChange={this.handleChange} placeholder="Enter GST Address"></textarea>

                        </div>
                      </div>

                      <div className="detail_inner margintop">
                        <span className="detailinner_header">BILL Address</span>
                        <div className="detailinner_input">
                          <textarea name="billing_Address" value={kycDetails.billing_Address ? kycDetails.billing_Address : ""}
                            onChange={this.handleChange} placeholder="Enter BILL Address"></textarea>

                        </div>
                      </div>


                      <div className="detail_inner margintop">
                        <span className="detailinner_header">GST Certificate</span>
                        <div className="detailinner_file">
                          <div className="detailefile_name">
                            {(kycDetails && kycDetails.gst_Certificate_file) ?
                              uploadedFileArr.includes('gst_Certificate_file') ? kycDetails.gst_Certificate_file[0] ?
                                kycDetails.gst_Certificate_file[0].name : "" :
                                kycDetails.gst_Certificate_file.slice(kycDetails.gst_Certificate_file.lastIndexOf('_') + 1) :
                              ""
                            }
                          </div>
                          <div className="detailfile_btns">
                               <div className="upload-btn-wrapper">
                              <button className="btn">CHANGE</button>
                              <input type="file" name="gst_Certificate_file" onChange={this.handleFiles}
                                accept=".jpeg, .png, .jpg, .svg"></input>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="detail_inner margintop">
                        <span className="detailinner_header">Billing Address Proof</span>
                        <div className="detailinner_file">
                          <div className="detailefile_name">
                            {(kycDetails && kycDetails.bill_address_cert_file) ?
                              uploadedFileArr.includes('bill_address_cert_file') ? kycDetails.bill_address_cert_file[0] ?
                                kycDetails.bill_address_cert_file[0].name : "" :
                                kycDetails.bill_address_cert_file.slice(kycDetails.bill_address_cert_file.lastIndexOf('_') + 1) :
                              ""
                            }
                          </div>
                          <div className="detailfile_btns">
                               <div className="upload-btn-wrapper">
                              <button className="btn">CHANGE</button>
                              <input type="file" name="bill_address_cert_file" onChange={this.handleFiles}
                                accept=".jpeg, .png, .jpg, .svg, .pdf"></input>
                            </div>
                          </div>
                        </div>
                      </div>





                    </div>
                    <h2 className="detail_kyc_header section_sep">SECONDARY DETAILS</h2>
                    <div className="wrapper_deials_kyc">
                      <div className="detail_inner">
                        <span className="detailinner_header">PAN Number</span>
                        <div className="detailinner_input">
                          <input type="text" name="pan_number" value={kycDetails.pan_number ? kycDetails.pan_number : ""}
                            onChange={this.handleChange} placeholder="Enter PAN Number" maxLength="10" pattern="[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}" required />
                        </div>
                      </div>
                      <div className="detail_inner">
                        <span className="detailinner_header">PANCARD Certificate</span>
                        <div className="detailinner_file">
                          <div className="detailefile_name">
                            {(kycDetails && kycDetails.pan_card_cert_file) ?
                              uploadedFileArr.includes('pan_card_cert_file') ? kycDetails.pan_card_cert_file[0] ?
                                kycDetails.pan_card_cert_file[0].name : "" :
                                kycDetails.pan_card_cert_file.slice(kycDetails.pan_card_cert_file.lastIndexOf('_') + 1) :
                              ""
                            }
                          </div>
                          <div className="detailfile_btns">
                            <div className="upload-btn-wrapper">
                              <button className="btn">CHANGE</button>
                              <input type="file" name="pan_card_cert_file" onChange={this.handleFiles}
                                accept=".jpeg, .png, .jpg, .svg" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="detail_inner">
                        <span className="detailinner_header">MSA</span>
                        <div className="detailinner_file">
                          <div className="detailefile_name">
                            {(kycDetails && kycDetails.msa_file) ?
                              uploadedFileArr.includes('msa_file') ? kycDetails.msa_file[0] ?
                                kycDetails.msa_file[0].name : "" :
                                kycDetails.msa_file.slice(kycDetails.msa_file.lastIndexOf('_') + 1) :
                              ""
                            }
                          </div>
                          <div className="detailfile_btns">
                            <div className="upload-btn-wrapper">
                              <button className="btn">CHANGE</button>
                              <input type="file" name="msa_file" onChange={this.handleFiles}
                                accept=".jpeg, .png, .jpg, .svg" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="detail_inner margintop">
                        <span className="detailinner_header">TAN Number</span>
                        <div className="detailinner_input">
                          <input type="text" name="tan_number" value={kycDetails.tan_number ? kycDetails.tan_number : ""}
                            onChange={this.handleChange} placeholder="Enter TAN Number" />
                        </div>
                      </div>
                      <div className="detail_inner margintop">
                        <span className="detailinner_header">TAN Certificate</span>
                        <div className="detailinner_file">
                          <div className="detailefile_name">
                            {(kycDetails && kycDetails.tan_cert_file) ?
                              uploadedFileArr.includes('tan_cert_file') ? kycDetails.tan_cert_file[0] ?
                                kycDetails.tan_cert_file[0].name : "" :
                                kycDetails.tan_cert_file.slice(kycDetails.tan_cert_file.lastIndexOf('_') + 1) :
                              ""
                            }
                          </div>
                          <div className="detailfile_btns">
                            <div className="upload-btn-wrapper">
                              <button className="btn">CHANGE</button>
                              <input type="file" name="tan_cert_file" onChange={this.handleFiles}
                                accept=".jpeg, .png, .jpg, .svg" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="save_details">
                      <button onClick={this.updateKycDetails}>SAVE</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  };
}

const mapDispatchToProps = dispatch => {
  return {
    updateKycDetails: (url, data, path) => dispatch(postServerDataWithPath(url, data, path))
  }
}

export default connect(null, mapDispatchToProps)(EditKycDetailComp);


// WEBPACK FOOTER //
// ./web/components/kyc_details/EditKycDetails.jsx